<script>
export default {
	data: () => ({
		showFull: false
	})
}
</script>
